import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import UsersAdminForm from "./UsersAdminForm";
import { onCreate } from "../../../api/legacy/UserAPI";
import "../../../css/admin/smartlist.scss";
import useAbility from "../../../hooks/useAbility";
import { validateUserStandardRegistration } from "../../../utils/data/Login";
import { PROJECTS_ROUTE } from "../../routes/routes";

import type { JSX } from "react";

import type { Notification, UpdatedUser } from "./UsersAdminForm";
import type { CreateUserResponse } from "../../../api/AdminUserAPI.types";
import type { AppState } from "../../../reducers";

export interface ValidUser {
  isValid?: boolean;
  error?: string;
}

export interface UserFormValues {
  email: string;
  first_name: string;
  last_name: string;
  password: string;
  logo: null | string;
  enabled: boolean;
}

function UsersAdminCreate(): JSX.Element {
  const [valid, setValid] = useState<ValidUser>({});
  const dispatch = useDispatch();
  const { t } = useTranslation("editor-users");
  const history = useHistory();

  const { token } = useSelector((state: AppState) => state.loginReducer);
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const orgaOptions = useSelector(
    (state: AppState) =>
      state.fetchReducer.orga_config.data?.organization_options,
  );

  const { canAccess } = useAbility();

  const { project: canAccessProject } = canAccess(orgaOptions);

  const user: UpdatedUser = {
    email: "",
    first_name: "",
    last_name: "",
    password: "",
    avatar: "",
    avatar_url: "",
    country: null,
    custom_1: null,
    custom_2: null,
    custom_3: null,
    has_2fa: false,
    has_stripe_acc: false,
    invoice_url: "",
    lang: "",
    organization_label: "",
    roles: [],
    uuid: "",
    inserted_at: "",
    internal_comment: "",
  };

  const notifications = {
    registration: false,
    create_password: false,
  };

  const userCreated = (res: CreateUserResponse): void => {
    if (res.uuid) {
      history.push(`${PROJECTS_ROUTE}/${projectSlug}/users/edit/${res.uuid}`);
    }
  };

  const onCreateUser = (item: UpdatedUser, notif?: Notification): void => {
    const validUser = validateUserStandardRegistration(item);

    setValid(validUser);

    if (!validUser.isValid) return;

    const newUser = {
      user: item,
      notifications: notif,
    };

    dispatch(onCreate(newUser, projectSlug, token, userCreated, t));
  };

  return (
    <UsersAdminForm
      commentsDisabled={!canAccessProject.community}
      isDisabled={!canAccessProject.usersWrite}
      item={user}
      notifications={notifications}
      onSubmit={onCreateUser}
      type="new"
      valid={valid}
    />
  );
}

export default UsersAdminCreate;
